import React from "react";
import { PlusIcon } from "../../svgIcons";
import { AspectItem } from "../Items/AspectItem";
export const Aspects = ({ items }) => (React.createElement("div", { className: "aspects-root" }, items.length > 0 && items.map((a, ind) => (React.createElement("div", { key: ind },
    React.createElement(AspectItem, { content: a.content, title: a.title }),
    ind !== items.length - 1 && React.createElement("div", { className: "plus-image-wrapper" }, PlusIcon()))))));
